import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tree } from 'antd';

import Tooltip from '../Tooltip';
import s from './Tree.pcss';


const TreeNode = Tree.TreeNode;

class TreeList extends Component {
  static propTypes = {
    tree: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    expandedKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    onExpand: PropTypes.func.isRequired,
    treeLeaf: PropTypes.func,
    treeNode: PropTypes.func,
    customTreeNode: PropTypes.bool,
    dragProps: PropTypes.shape(),
    localIdent: PropTypes.number,
    selectedFolder: PropTypes.string,
  };

  static defaultProps = {
    treeLeaf: null,
    treeNode: null,
    customTreeNode: false,
    localIdent: null,
    dragProps: {},
    selectedFolder: null,
  };

  toggleNode = (selectedKeys, event) => {
    this.props.onExpand(event.node.props.node);
  };

  renderTitle = (node, localOrder) => {
    const { expandedKeys, treeLeaf, treeNode, customTreeNode, localIdent } = this.props;
    const expanded = expandedKeys.includes(node.id);
    let className = this.props.selectedFolder === node.id ? `${s.node} ${s.selectedNode}` : s.node;
    const style = {};
    if (node.weightIndex === 0) {
      style.fontSize = 18;
      style.color = '#202124';
      style.fontWeight = 400;
    }
    if (node.indent) {
      style.marginLeft = node.indent;
    }
    if (localIdent) {
      style.marginLeft = localIdent * localOrder;
    }
    if (node.isLeaf) {
      className = s.leaf;
      return (
        <div className={className}>
          {treeLeaf(node, expanded)}
        </div>
      );
    }
    const content = treeNode ? treeNode(node) : node.name;
    if (customTreeNode && treeNode) {
      return (
        <div className={className}>
          <div className={`${s.nodeName} ${expanded ? s.expandedNode : ''}`} style={style}>
            {content}
          </div>
        </div>
      );
    }
    return (
      <div className={className}>
        <div>
          <Tooltip tip={node.name} className={s.tooltipContainer} ckeckOverflow>
            <div className={`${s.nodeName} ${expanded ? s.expandedNode : ''}`} style={style}>
              {content}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };

  renderTreeNode = (node, localOrder) => {
    const { expandedKeys } = this.props;
    const selected = expandedKeys.includes(node.id);
    const sectionSelected = node.weightIndex === 0 && selected && node.children && node.children.length > 0;
    const className = sectionSelected ? s.sectionSelected : '';
    return (
      <TreeNode className={className} title={this.renderTitle(node, localOrder)} node={node} key={node.id}>
        {node.children && node.children.length > 0 &&
          node.children.map(child => this.renderTreeNode(child, localOrder + 1))
        }
      </TreeNode>
    );
  };

  render() {
    const { tree, expandedKeys, dragProps } = this.props;
    if (!tree) return null;
    const localOrder = 0;
    return (
      <div className={s.treeContainer}>
        <Tree expandedKeys={expandedKeys} onSelect={this.toggleNode} {...dragProps}>
          {tree.map(node => this.renderTreeNode(node, localOrder))}
        </Tree>
      </div>
    );
  }
}

export default TreeList;



// WEBPACK FOOTER //
// ./src/shared/components/Tree/TreeList.js